import { defineComponent as _defineComponent } from 'vue';
import { BBadge } from "bootstrap-vue";
import { useHistoryStore } from "@/stores/historyStore";
import TextSummary from "@/components/Common/TextSummary.vue";
import DetailsLayout from "@/components/History/Layout/DetailsLayout.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDetails',
    props: {
        history: null,
        writeable: { type: Boolean, default: true },
        summarized: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const historyStore = useHistoryStore();
        function onSave(newDetails) {
            const id = props.history.id;
            historyStore.updateHistory(Object.assign(Object.assign({}, newDetails), { id }));
        }
        return { __sfc: true, props, historyStore, onSave, BBadge, TextSummary, DetailsLayout, UtcDate };
    }
});
